import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { matchPath } from 'react-router-dom';
import { useBaseHistory } from 'spindl-shared-components';

import { CommunicationsMainLayoutCombinedProps } from './types';

const usePresenter = (props: CommunicationsMainLayoutCombinedProps): CommunicationsMainLayoutCombinedProps => {
  const history = useBaseHistory();
  const { t } = useTranslation();
  const [pathname, setPathname] = useState<string>(history.location.pathname);

  const changeTab = (tabPath: string) => {
    history.push(tabPath);
    setPathname(tabPath);
  };

  const matchTabPath = (tabPath: string): boolean => {
    return !!matchPath(pathname, tabPath);
  };

  return {
    ...props,
    horizontalTabList: {
      horizontalTabItems: [
        {
          state: matchTabPath('/') ? 'Selected' : 'Unselected',
          text: {
            value: t('tab_list.email_templates'),
          },
          onClick: () => changeTab('/'),
        },
        // {
        //   state: matchTabPath(`${basePath}/activity`) ? 'Selected' : 'Unselected',
        //   text: {
        //     value: t('tab_list.activity'),
        //   },
        //   onClick: () => changeTab('/activity'),
        // },
      ],
    },
  };
};

export default usePresenter;
